
import { get, post, patch } from "@/lib/fetcher";

/**
 * Fetch all Venues
 */
export async function getVenues() {
    return await get("/admin/venues");
}

export async function getVenue(id) {
    return await get(`/admin/venues/${id}`);
}

/**
 * Create a new skill
 * @param {Object} data - { category, skill, starting_price, top_price, price_unit }
 */
export async function postVenue(data) {
    return await post("/admin/venues", data);
}

/**
 * Update an existing skill by ID
 * @param {string|number} id - the skill ID
 * @param {Object} data - updated skill data
 */
export async function patchVenue(id, data) {
    return await patch("/admin/venues", id, data);
}
